import { CALL_API } from '../middleware/ApiMiddleware';

export const CE_LIBRARY_URL_FETCH_REQUEST = 'CE_LIBRARY_URL_FETCH_REQUEST';
export const CE_LIBRARY_URL_FETCH_SUCCESS = 'CE_LIBRARY_URL_FETCH_SUCCESS';
export const CE_LIBRARY_URL_FETCH_FAILURE = 'CE_LIBRARY_URL_FETCH_FAILURE';

export const CE_LIBRARY_URL_EDIT_REQUEST = 'CE_LIBRARY_URL_EDIT_REQUEST';
export const CE_LIBRARY_URL_EDIT_SUCCESS = 'CE_LIBRARY_URL_EDIT_SUCCESS';
export const CE_LIBRARY_URL_EDIT_FAILURE = 'MUNICIPAL_CODE_EDIT_FAILURE';

const baseURL = 'xerce/config/code-enforcement-library-url';

export const fetchCeLibraryUrl = () => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'get',
    authenticated: true,
    types: [CE_LIBRARY_URL_FETCH_REQUEST, CE_LIBRARY_URL_FETCH_SUCCESS, CE_LIBRARY_URL_FETCH_FAILURE],
  },
});

export const editCodeEnforcementLibraryUrl = (codeEnforcementLibrary: ICodeEnforcementLibraryUrlRequest) => ({
  [CALL_API]: {
    endpoint: `${baseURL}`,
    method: 'put',
    authenticated: true,
    body: codeEnforcementLibrary,
    types: [CE_LIBRARY_URL_EDIT_REQUEST, CE_LIBRARY_URL_EDIT_SUCCESS, CE_LIBRARY_URL_EDIT_FAILURE],
  },
});
